// extracted by mini-css-extract-plugin
export default {"maxWidth":"kioskPaymentScreens_maxWidth__b3ult"};